<script setup>
import { CsTag } from 'dashboard/components/ui/commslayer';
import { NodeViewWrapper } from '@tiptap/vue-2';

const props = defineProps({
  editor: {
    type: Object,
    required: true,
  },
  node: {
    type: Object,
    required: true,
  },
  getPos: {
    type: Function,
    required: true,
  },
});

function handleRemove() {
  const currentPos = props.getPos();
  props.editor.commands.removeVariableMention(props.node.attrs.id);

  // Focus on the position before the removed node
  props.editor.commands.focus(currentPos);
}
</script>

<template>
  <NodeViewWrapper as="span" style="display: inline">
    <CsTag
      :data-id="props.node.attrs.id"
      :data-label="props.node.attrs.label"
      :data-value="props.node.attrs.value"
      :is-closable="true"
      variant-color="default"
      class="font-semibold font-mono tracking-tighter"
      @remove="handleRemove"
    >
      {{ props.node.attrs.label ? `\{\{${props.node.attrs.label}\}\}` : '' }}
    </CsTag>
  </NodeViewWrapper>
</template>
